<template>
    <kt-row>
        <kt-col lg="4" md="6" sm="12">
            <kt-form-group>
                <kt-form-label for="mellat_bill_code">
                    {{ $t('bill-service.mellat_bill_code') }}
                </kt-form-label>
                <kt-form-control
                        id="mellat_bill_code"
                        name="mellat_bill_code"
                        type="number"
                        style="direction: ltr"
                        v-model="form_data.mellat_bill_code"
                        class="form-control"
                ></kt-form-control>
            </kt-form-group>
        </kt-col>
    </kt-row>
</template>

<script>
import $ from "jquery";
import Inputmask from "inputmask";
import {i18n} from '@/plugins/i18n'

export default {
    props: {
        form_data: {
            required: true
        },
    },

}
</script>

<style scoped>
.label-file {
    border: 1px solid #ccc;
    width: fit-content;
    cursor: pointer;
    min-width: 200px;
}

input[type="file"]::-webkit-file-upload-button {
    visibility: hidden;
}
</style>